export default __webpack_public_path__ + "static/media/la2.2.82135f8c.png";